<template>
  <div class="d-flex table-container">
    <table class="mark-table">
      <thead>
        <tr>
          <th rowspan="2">Môn học</th>
          <th
            v-for="semester in semestersData"
            :key="semester.id"
            class="semseter-header"
            :colspan="semester.maxFactor"
          >
            {{ semester.title }}
          </th>
        </tr>
        <tr>
          <td v-for="(factor, index) in factorList" :key="index" :colspan="factor.maxColumn">
            {{ factor.title }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in subjectMarks" :key="index">
          <td>{{ item.subject.title }}</td>

          <td v-for="(mark, index) in item.marks" :key="index">
            <span v-if="item.subject.markType === 'mark'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <span v-bind="attrs" v-on="on">
                      {{ mark.value }}
                    </span>
                  </div>
                </template>
                <span>{{ mark.date | ddmmyyyy }}</span>
              </v-tooltip>
            </span>
            <span v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <span style="white-space: nowrap;" v-bind="attrs" v-on="on">
                      {{ mark.value | getEvaluate }}
                    </span>
                  </div>
                </template>
                <span>{{ mark.date | ddmmyyyy }}</span>
              </v-tooltip>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('StudentMark', ['subjects', 'semestersData']),
    factorList() {
      let factors = []
      this.semestersData.map(semester => {
        factors = [...factors, ...semester.factors]
      })
      return factors
    },
    subjectMarks() {
      const subjectMarks = this.subjects.map(subject => {
        let marks = []
        this.semestersData.map(semester => {
          const semesterSubjectMark = semester.subjectMarks.find(sb => sb.subject.id === subject.id)
          if (semesterSubjectMark) {
            marks = [...marks, ...semesterSubjectMark.marks]
          }
        })
        return {
          subject,
          marks
        }
      })
      return subjectMarks
    }
  },
  methods: {
    ...mapActions('StudentMark', ['fetchStudentMarks']),
    async refresh(query) {
      this.$loading.active = true
      try {
        await this.fetchStudentMarks(query)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mark-table {
  td,
  tr,
  th {
    border: 1px solid #e0e0e0;
  }
  td,
  th {
    padding: 14px 20px;
    text-align: center;
  }
  .semseter-header {
    font-size: 20px;
    color: #0d47a1;
    text-transform: uppercase;
  }
  color: #212121;
  border-collapse: collapse;
  width: 100%;
}
.table-container {
  overflow: auto;
  max-width: 100%;
}
</style>
